import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import * as FiIcons from 'react-icons/fi';

/**
 * T12.6 — destructive-action confirm modal: the user must type CONFIRM
 * before the action executes. Shared by the emergency controls.
 */
function ConfirmActionModal({ action, onClose, onConfirm }) {
  const [confirmation, setConfirmation] = useState('');
  const inputRef = useRef(null);
  const armed = confirmation.trim().toUpperCase() === 'CONFIRM';

  useEffect(() => {
    inputRef.current?.focus();
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (domEvent) => {
      if (domEvent.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return createPortal(
    (
      <div className="modal-backdrop modal-backdrop--danger" onClick={onClose}>
        <div
          aria-modal="true"
          className="modal modal--danger"
          onClick={(domEvent) => domEvent.stopPropagation()}
          role="alertdialog"
        >
          <header className="modal__head">
            <h2><FiIcons.FiAlertTriangle /> {action.title}</h2>
            <button className="modal__close" onClick={onClose} type="button">
              <FiIcons.FiX />
            </button>
          </header>

          <div className="modal__body">
            <p className="modal__warning">{action.warning}</p>
            <p className="modal__instruction">
              Type <strong>CONFIRM</strong> to execute. This action is recorded in the audit trail.
            </p>
            <input
              onChange={(domEvent) => setConfirmation(domEvent.target.value)}
              onPaste={(domEvent) => domEvent.preventDefault()}
              placeholder="CONFIRM"
              ref={inputRef}
              value={confirmation}
            />
          </div>

          <footer className="modal__actions">
            <button className="ghost-button" onClick={onClose} type="button">Cancel</button>
            <button
              className="danger-button"
              disabled={!armed}
              onClick={() => onConfirm(action)}
              type="button"
            >
              Execute {action.shortLabel}
            </button>
          </footer>
        </div>
      </div>
    ),
    document.body
  );
}

export default ConfirmActionModal;
